import { styled } from "@linaria/react";
import React from "react";
import type { User } from "../../../api/useUser";
import { canUserDo } from "diagnostics-domain/canUserDo";
import t from "../../../i18n";
import ButtonIconV2 from "@ui/ButtonIconV2";
import { DeleteBinLine } from "@ui/IconV2/react";

interface P {
  user: User;
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
}

const ActionIcons = styled.div`
  height: 30px;
  margin-left: auto;
  flex-grow: 0;
  align-items: center;
  display: none;
  cursor: pointer;
  tr:hover & {
    display: block;
  }
`;

const DeleteUserAction = ({ onClick, user }: P) => {
  const hasUserDeletePermission = canUserDo(user, "ADMIN_USER_MANAGE");

  return (
    hasUserDeletePermission && (
      <ActionIcons>
        <ButtonIconV2 title={t("users.table.row.icons.delete.user")} onClick={onClick}>
          <DeleteBinLine size="m" />
        </ButtonIconV2>
      </ActionIcons>
    )
  );
};

export default DeleteUserAction;
